import { connect, type ConnectedProps } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'next/router';
import { AccountInformation } from '@/components/account/accountInformation';
import { ContactInformation } from '@/components/account/personalInformation';
import { StoredAddresses } from '@/components/account/storedAddresses';
import {
  StyledAccountContainer,
  StyledFlexedHeader,
  StyledLoyaltyContainer,
} from '@/components/account/styles';
import UpdatePassword from '@/components/account/updatePassword';
import { UserBirthday } from '@/components/account/userBirthday';
import Layout from '@/components/app/layout/index';
import StringAccessor from '@/components/cmsConfig/stringAccessor';
import { RestrictedAccountRoute } from '@/components/restrict';
import { StyledPaddingContainer } from '@/components/uielements/forms';
import { StyledPrimaryButton } from '@/components/uielements/primaryButton/styles';
import { CSS_CLASSES } from '@/constants/cssClassNames';
import authActions from '@/redux/auth/actions';
import { type RootState } from '@/types/app';
import DeleteAccount from '@/components/account/deleteAccount/deleteAccount';

const AccountPage = ({ logout, authLoading }: ReduxProps) => {
  return (
    <RestrictedAccountRoute>
      <Layout $backgroundOverride={true}>
        <StyledLoyaltyContainer>
          <StyledPaddingContainer>
            <StyledFlexedHeader className={CSS_CLASSES.LOYALTY.PAGE_HEADER}>
              {/* TODO - Move into own component? */}
              <StringAccessor tag="h2" accessor="account.header" html={true} />
              <StyledPrimaryButton
                data-css-override="StyledPrimaryButton"
                aria-label="Click to Sign Out"
                onClick={() => logout()}
                $buttonTheme="knockout"
                $submitting={authLoading}
              >
                <StringAccessor accessor="account.sign_out_button" />
              </StyledPrimaryButton>
            </StyledFlexedHeader>

            <StyledAccountContainer>
              {/* Contact Info Section */}
              <ContactInformation />

              {/* Account Info Section */}
              <AccountInformation />

              {/* Stored Addresses Section */}
              <StoredAddresses />

              {/* User Birthday Section */}
              <UserBirthday />

              {/* Update Password Section */}
              <UpdatePassword />

              {/* Delete Account */}
              <DeleteAccount />
            </StyledAccountContainer>
          </StyledPaddingContainer>
        </StyledLoyaltyContainer>
      </Layout>
    </RestrictedAccountRoute>
  );
};

const mapStateToProps = (state: RootState) => ({
  authLoading: state.app.auth.loading,
});

const mapDispatchToProps = {
  logout: authActions.logout,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default compose(connector, withRouter)(AccountPage);
